// extracted by mini-css-extract-plugin
export var container = "ShufflerLayout-module--container--031ce";
export var controls = "ShufflerLayout-module--controls--5bf33";
export var header = "ShufflerLayout-module--header--a0a00";
export var stats = "ShufflerLayout-module--stats--8b877";
export var title = "ShufflerLayout-module--title--b1a74";